export const addToCart = (cart, product) => {
  // Si el producto ya tiene itemKey (viene de una selección de color), úsalo; si no, asígnale uno único
  let itemKey = product.itemKey;
  if (!itemKey) {
    if (product.selectedColor) {
      itemKey = `${product.id}-${product.selectedColor}`;
    } else {
      // Si no tiene color, genera un itemKey único (puede haber más de uno igual en el carrito)
      itemKey = `${product.id}-${Date.now()}-${Math.random().toString(36).substr(2, 9)}`;
    }
  }

  // Copiar price y pricears explícitamente si existen
  const productWithPrices = {
    ...product,
    price: product.price !== undefined ? product.price : 0,
    pricears: product.pricears !== undefined ? product.pricears : 0
  };

  // Buscar si ya existe un item con el mismo itemKey
  const existingItem = cart.find(item => item.itemKey === itemKey);

  if (existingItem) {
    return cart.map(item =>
      item.itemKey === itemKey
        ? { ...item, quantity: item.quantity + (product.quantity || 1) }
        : item
    );
  }

  return [...cart, { ...productWithPrices, itemKey, quantity: product.quantity || 1 }];
};

export const removeFromCart = (cart, itemKey) => {
  return cart.filter(item => item.itemKey !== itemKey);
};

export const updateQuantity = (cart, itemKey, newQuantity) => {
  if (newQuantity <= 0) {
    return removeFromCart(cart, itemKey);
  }
  return cart.map(item =>
    item.itemKey === itemKey
      ? { ...item, quantity: newQuantity }
      : item
  );
};